// extracted by mini-css-extract-plugin
module.exports = {"container":"section3_container__gL2oQ","content":"section3_content__3ch0B","title":"section3_title__QLf0H","cards":"section3_cards__I29Yx"};